import { graphql } from 'gatsby'
import React from 'react'

interface VideoEmbedProps {
  block: {
    _template: string
    css_class_name: string
    html: string
    max_width?: string
  }
}

/*
Example of Bunny Stream's style overrides.
These are defined in Dashboard > Stream > Player > Custom HTML Head

<style>
.plyr__control--overlaid {
  background: linear-gradient(0deg, #03192E 0%, #223C6A 60.67%, #4A74A2 100%);
}
.plyr--video .plyr__control:hover {
  background: linear-gradient(0deg, #03192E 0%, #223C6A 60.67%, #4A74A2 100%) !important;
}
.plyr--video {
  border: 4px white solid;
  border-radius: 8px;
}
</style>
*/

const VideoEmbed: React.FC<VideoEmbedProps> = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className='row'>
        <div className={block.max_width ? 'col-lg-10 offset-lg-1' : block.max_width}>
          <div className="video-wr" dangerouslySetInnerHTML={{__html: block.html}}></div>
        </div>
      </div>
    </div>
  </section>
)

export default VideoEmbed

export const videoEmbedFragmentQuery = graphql`
  fragment VideoEmbedBlockFragment on Block {
    _template
    css_class_name
    html
    max_width
  }
`;
